import React from 'react';
import { useTranslation } from 'react-i18next';

const BulkUpdateConfirmationModal = ({
  setConfirmationModal,
  onSuccess,
  loading,
}) => {
  const { t } = useTranslation('Order');

  const saveSubmit = async () => {
    await onSuccess();
  };
  const handleCancel = async () => {
    setConfirmationModal(false);
  };
  return (
    <div className="modal fade show d-block add-new-fbz" id="add-order-modal">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5">{t('CONFIRMATION')}</h1>
            <button
              type="button"
              className="btn-close"
              onClick={() => setConfirmationModal(false)}
            ></button>
          </div>
          <div className="modal-body">
            <h3>{t('AREYOUSURE?')}</h3>
            <div className="bottom-button">
              <button
                className={`cancel ${loading ? 'disable-btn' : ''}`}
                onClick={() => handleCancel()}
              >
                {t('CANCEL')}
              </button>
              <button
                className={`save ${loading ? 'disable-btn' : ''}`}
                onClick={() => saveSubmit()}
              >
                {loading ? t('LOADING') : t('CONFIRM')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default BulkUpdateConfirmationModal;
